import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', event => {
  /** * Instagram Mobile Slider ***/
  const inUseSlider = document.querySelector('.in-use__photos');

  const flickity = new Flickity(inUseSlider, {
    pageDots: true,
    prevNextButtons: false,
    wrapAround: true,
    watchCSS: true,
  });
});
